import { render } from "./DirectStockingTable.vue?vue&type=template&id=61627dca"
import script from "./DirectStockingTable.vue?vue&type=script&lang=js"
export * from "./DirectStockingTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__